import type { RHFGroupFieldValue } from '@/components/dynamic-filter/FilterFormGroup';
import type { ComponentCategoryResponse } from '@/types/apps/component-category.type';
import type { GqlListResponse } from '@/types/common/api.type';
import { BaseService } from '@/types/service/graphql-service.type';

export interface ComponentCategoryGraphQLServiceInterface {}

type ComponentCategoryGraphQLListResponse =
    GqlListResponse<ComponentCategoryResponse>;

export class ComponentCategoryGraphQLService
    extends BaseService
    implements ComponentCategoryGraphQLServiceInterface
{
    public getEntityName(): string {
        return 'partCategory';
    }

    public getFields(): Record<string, any> {
        return {
            code: true,
            createdBy: true,
            createdDate: true,
            deletedAt: true,
            deletedBy: true,
            description: true,
            id: true,
            isDeleted: true,
            modifiedBy: true,
            modifiedDate: true,
            name: true,
        };
    }

    public async index(
        query: string
    ): Promise<ComponentCategoryGraphQLListResponse> {
        return this.fetchGqlList<ComponentCategoryGraphQLListResponse>(
            query,
            this.getEntityName()
        );
    }

    public getFilterByRole(): Record<string, RHFGroupFieldValue> {
        if (!this.getQueryById() || !this.getRoleTypeManager().getQuery) {
            return {};
        }

        return this.getRoleTypeManager().getQuery('componentCategory', {
            userId: this.getQueryById(),
        });
    }
}
